export const GET_VFUS_FAILURE = "GET_VFUS_FAILURE";
export const GET_VFUS_REQUEST = "GET_VFUS_REQUEST";
export const GET_VFUS_SUCCESS = "GET_VFUS_SUCCESS";

export const GET_PGUS_FAILURE = "GET_PGUS_FAILURE";
export const GET_PGUS_REQUEST = "GET_PGUS_REQUEST";
export const GET_PGUS_SUCCESS = "GET_PGUS_SUCCESS";

export const GET_PG_DEVICES_FAILURE = "GET_PG_DEVICES_FAILURE";
export const GET_PG_DEVICES_REQUEST = "GET_PG_DEVICES_REQUEST";
export const GET_PG_DEVICES_SUCCESS = "GET_PG_DEVICES_SUCCESS";

export const GET_TEMPERATURE_DATA_FAILURE = "GET_TEMPERATURE_DATA_FAILURE";
export const GET_TEMPERATURE_DATA_REQUEST = "GET_TEMPERATURE_DATA_REQUEST";
export const GET_TEMPERATURE_DATA_SUCCESS = "GET_TEMPERATURE_DATA_SUCCESS";

export const GET_HUMIDITY_DATA_FAILURE = "GET_HUMIDITY_DATA_FAILURE";
export const GET_HUMIDITY_DATA_REQUEST = "GET_HUMIDITY_DATA_REQUEST";
export const GET_HUMIDITY_DATA_SUCCESS = "GET_HUMIDITY_DATA_SUCCESS";

export const GET_CO_TWO_DATA_FAILURE = "GET_CO_TWO_DATA_FAILURE";
export const GET_CO_TWO_DATA_REQUEST = "GET_CO_TWO_DATA_REQUEST";
export const GET_CO_TWO_DATA_SUCCESS = "GET_CO_TWO_DATA_SUCCESS";

export const GET_ZONE_DEVICE_FAILURE = "GET_ZONE_DEVICE_FAILURE";
export const GET_ZONE_DEVICE_REQUEST = "GET_ZONE_DEVICE_REQUEST";
export const GET_ZONE_DEVICE_SUCCESS = "GET_ZONE_DEVICE_SUCCESS";

export const GET_IRRIGATION_ZONE_FAILURE = "GET_IRRIGATION_ZONE_FAILURE";
export const GET_IRRIGATION_ZONE_REQUEST = "GET_IRRIGATION_ZONE_REQUEST";
export const GET_IRRIGATION_ZONE_SUCCESS = "GET_IRRIGATION_ZONE_SUCCESS";

export const GET_CO2_ZONE_FAILURE = "GET_CO2_ZONE_FAILURE";
export const GET_CO2_ZONE_REQUEST = "GET_CO2_ZONE_REQUEST";
export const GET_CO2_ZONE_SUCCESS = "GET_CO2_ZONE_SUCCESS";

export const GET_WORK_ZONE_FAILURE = "GET_WORK_ZONE_FAILURE";
export const GET_WORK_ZONE_REQUEST = "GET_WORK_ZONE_REQUEST";
export const GET_WORK_ZONE_SUCCESS = "GET_WORK_ZONE_SUCCESS";

export const GET_GROW_ZONE_FAILURE = "GET_GROW_ZONE_FAILURE";
export const GET_GROW_ZONE_REQUEST = "GET_GROW_ZONE_REQUEST";
export const GET_GROW_ZONE_SUCCESS = "GET_GROW_ZONE_SUCCESS";

export const GET_EXECUTE_VFU_BATCH_FAILURE = "GET_EXECUTE_VFU_BATCH_FAILURE";
export const GET_EXECUTE_VFU_BATCH_REQUEST = "GET_EXECUTE_VFU_BATCH_REQUEST";
export const GET_EXECUTE_VFU_BATCH_SUCCESS = "GET_EXECUTE_VFU_BATCH_SUCCESS";

